import QRCode from 'qrcode'
import { BASE_HOST } from '@qctsw/common'
import { isClient } from '@qctsw/utils'
import { SYMBOL_SHARE_BASE } from '@/shared/constants'

export interface ShareBase {
  url: string
  title: string
  images?: string[] | undefined
  content: string
}

// qzone: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={{URL}}&title={{TITLE}}&desc={{DESCRIPTION}}&summary={{SUMMARY}}&site={{SOURCE}}&pics={{IMAGE}}',
// qq: 'http://connect.qq.com/widget/shareqq/index.html?url={{URL}}&title={{TITLE}}&source={{SOURCE}}&desc={{DESCRIPTION}}&pics={{IMAGE}}&summary="{{SUMMARY}}"',

export function useShare() {
  const shareBase = ref<ShareBase | undefined>(undefined)

  function setShareBase(data: ShareBase) {
    shareBase.value = data
  }

  if (isClient)
    provide(unref(SYMBOL_SHARE_BASE()), shareBase)
  return {
    shareBase,
    setShareBase,
  }
}

interface KEYS {
  WEIBOKEY?: string
  QZONEKEY?: string
}
export function useShareSetting(KEYS?: KEYS) {
  const shareBase = inject<Ref<ShareBase | undefined>>(unref(SYMBOL_SHARE_BASE()), ref(undefined))

  const source = '汽车投诉网'
  const summary = '专业的汽车质量投诉平台！'
  // 新浪分享
  const weiboKey = ref(KEYS?.WEIBOKEY ?? '')
  const weiboShareUrl = computed(() => {
    const { url, title, images = [] } = unref(shareBase) || {}
    let str = `https://service.weibo.com/share/share.php?url=${url}&title=${title}`
    if (images && images.length) {
      images.forEach((v) => {
        str += `&pic=${v}`
      })
    }
    return str
  })

  // qq、qq空间分享
  const qzoneShareUrl = computed(() => {
    const { url, title, content = '', images = [] } = unref(shareBase) || {}
    let str = `https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&desc=${content.slice(0, 25)}&summary=${summary}&site=${source}`
    if (images && images.length)
      str += `&pics=${images[0]}`

    return str
  })

  const weixinQrcode = ref('')
  const generateCode = (url: string) => {
    QRCode.toDataURL(url)
      .then((url: any) => {
        weixinQrcode.value = url
        // console.log('url', url)
      })
      .catch((err: any) => {
        console.error(`generateCode${err}`)
      })
  }
  const isHash = false
  const prePath = isHash ? '/h5/#/' : '/h5/'
  const route = useRoute()
  function changeWebDetail(href: string) {
    const detailList: [RegExp, string][] = [
      [/news\/media/, `${prePath}subpages/pages/index/media?data_id=`], // 资讯详情
      [/news\/author/, `${prePath}subpages/pages/index/author?data_id=`], // 资讯详情
      [/news\/detail/, `${prePath}subpages/pages/index/detail?data_id=`], // 资讯详情
      [/complaint\/detail/, `${prePath}subpages/pages/complaint/detail?data_id=`], // 投诉详情
      [/complaint\/collective/, `${prePath}subpages/pages/complaint/detail-collective?data_id=`], // 集体投诉详情
    ]
    for (const item of detailList) {
      if (item[0].test(href)) {
        const id = route.params?.id
        // console.log(`${BASE_HOST || window.location.origin}${item[1] + id}&share=${Date.now()}`)
        return `${BASE_HOST || window.location.origin}${item[1] + id}&share=${Date.now()}`
      }
    }
    return href
  }
  watch(() => unref(shareBase)?.url, (nv) => {
    if (nv) {
      const href = changeWebDetail(nv)
      generateCode(href)
    }
  }, {
    immediate: true,
  })

  return {
    weiboKey,
    weiboShareUrl,
    qzoneShareUrl,
    weixinQrcode,
  }
}
